import React from 'react'
import { Router } from 'react-router-dom'
import { renderRoutes } from 'react-router-config'
import { createBrowserHistory } from 'history'
import MomentUtils from '@date-io/moment'
import { Provider as StoreProvider } from 'react-redux'
import { ThemeProvider } from '@material-ui/styles'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import 'react-perfect-scrollbar/dist/css/styles.css'
import { theme } from './theme'
import { configureStore } from './store'
import routes from './routes'
// import CookiesNotification from './components/CookiesNotification'
import ScrollReset from './components/ScrollReset'
import StylesProvider from './components/StylesProvider'
import './mixins/chartjs'
import './mixins/moment'
import './mixins/validate'
import './mixins/prismjs'
import './assets/scss/main.scss'
import preval from 'preval.macro'
import './i18n'

const history = createBrowserHistory()
const store = configureStore()

const buildDate = preval`
const moment = require('moment')
const buildTimestamp = moment().format('DD/MM/YYYY HH:mm:ss')
module.exports = buildTimestamp
`

console.log(buildDate)

function App () {
  // useEffect(() => {
  //   window.$crisp = []
  //   window.CRISP_WEBSITE_ID = '9e915768-6bc3-4df4-ba03-e21659bc2aba';
  //
  //   (function () {
  //     var d = document
  //     var s = d.createElement('script')
  //
  //     s.src = 'https://client.crisp.chat/l.js'
  //     s.async = 1
  //     d.getElementsByTagName('head')[0].appendChild(s)
  //   })()
  // })
  return (
    <StoreProvider store={store}>
      <ThemeProvider theme={theme}>
        <StylesProvider>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <Router history={history}>
              <ScrollReset />
              {/* <CookiesNotification /> */}
              {renderRoutes(routes)}
            </Router>
          </MuiPickersUtilsProvider>
        </StylesProvider>
      </ThemeProvider>
    </StoreProvider>
  )
}

export default App
